var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "d-flex field field--quantity flex-row justify-content-end h-100",
    },
    [
      _vm.label
        ? _c("label", { staticClass: "mr-3 ml-0 font-weight-light" }, [
            _vm._v("\n    " + _vm._s(_vm.label) + ":\n  "),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "border-right-0 h-100 border",
          attrs: { type: "button" },
          on: { click: _vm.handleClickDecrease },
        },
        [_vm._v("\n    -\n  ")]
      ),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.quantity,
            expression: "quantity",
          },
        ],
        staticClass: "text-center border-left-0 border-right-0",
        attrs: { type: "number", maxlength: "2", title: _vm.label },
        domProps: { value: _vm.quantity },
        on: {
          input: [
            function ($event) {
              if ($event.target.composing) return
              _vm.quantity = $event.target.value
            },
            _vm.handleInput,
          ],
        },
      }),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "border-left-0 h-100 border",
          attrs: { type: "button" },
          on: { click: _vm.handleClickIncrease },
        },
        [_vm._v("\n    +\n  ")]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }